var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"th",class:_vm.cssClass,on:{"click":_vm.change}},[_vm._t("default"),(!_vm.disabled)?_c('span',{staticClass:"c-btn c-btn--sort"}):_vm._e(),_vm._t("tooltip")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }